// RITA-1522 (Nutzungserfassung Phase 3d, Epic RITA-1496) — der Platz, den die Leiste belegt.
//
// Die Leiste liegt fix am unteren Fensterrand auf appBar+1 und lag damit ÜBER allem, was dort
// klebt: über dem Einstellungs-Zahnrad (zIndex 999, bottom 24) — dem EINZIGEN Weg in den Drawer,
// über den die Heatmap überhaupt geschaltet wird — und über dem untersten Bildbereich jeder
// Seite. Verdecken statt Platz schaffen widerspricht Kontrakt 9 („Bedienung bleibt frei“).
//
// Die Leiste veröffentlicht deshalb ihre GEMESSENE Höhe als CSS-Variable am Wurzelelement (sie
// ändert sich beim Ein-/Ausklappen, beim Aufklappen der Grenzen und beim Umbrechen). Wer unten am
// Fenster klebt, liest sie: das Zahnrad hebt sich um diese Höhe an, der Inhaltsbereich hängt sie
// als Abstand unten an. Ausgeschaltet ist die Variable nicht gesetzt — der Ersatzwert 0px lässt
// beide Stellen unverändert, ohne dass sie vom Overlay wissen müssten.

/** Name der CSS-Variablen am Wurzelelement. */
export const HEATMAP_LEISTE_HOEHE = '--heatmap-leiste-hoehe';

/** Wert für Stellen, die sich diesen Platz freihalten: Höhe der Leiste, sonst 0. */
export const HEATMAP_LEISTE_PLATZ = `var(${HEATMAP_LEISTE_HOEHE}, 0px)`;
